// @flow
import React, { Component, Fragment } from 'react';
import type { State } from 'store';
import { connect } from 'react-redux';
import BrandComments from 'components/brand/BrandComments/BrandComments';
import BrandCommentInput from 'components/brand/BrandCommentInput/BrandCommentInput';
import { BrandsActions } from 'store/actionCreators';
import type { Comment, RemoveComment, SubCommentsMap } from 'store/modules/brands';
import QuestionModal from 'components/common/QuestionModal';
import { type ContextRouter, withRouter } from 'react-router-dom';

type Props = {
  brandId: ?string,
  comments: ?(Comment[]),
  subCommentsMap: SubCommentsMap,
  shouldCancel: boolean,
  logged: boolean,
  loading: boolean,
  username: ?string,
  removeComment: RemoveComment,
  commentsCount: ?number,
} & ContextRouter;

class BrandCommentsContainer extends Component<Props> {
  onOpenRemove = (payload: { commentId: string, parentId: ?string }) => {
    BrandsActions.openCommentRemove(payload);
  };

  onCancelRemove = () => {
    BrandsActions.cancelCommentRemove();
  };

  onConfirmRemove = () => {
    const { brandId, removeComment } = this.props;
    if (!brandId || !removeComment.commentId) return;
    BrandsActions.removeComment({
      brandId,
      commentId: removeComment.commentId,
    });
  };

  onEditComment = ({
    commentId,
    parentId,
    text,
  }: {
    commentId: string,
    parentId: ?string,
    text: string,
  }) => {
    const { brandId } = this.props;
    if (!brandId) return Promise.resolve();
    return BrandsActions.editComment({
      brandId,
      commentId,
      text,
      parentId,
    });
  };

  onWriteComment = async (text: string, replyTo: ?string, parentId?: ?string) => {
    const { brandId } = this.props;
    if (!brandId) return Promise.resolve();
    let comment = null;
    try {
      comment = await BrandsActions.writeComment({
        brandId,
        text,
        replyTo,
      });
      if (replyTo) {
        await this.onReadReplies(replyTo, parentId);
      } else {
        await BrandsActions.readComments({ brandId });
      }
    } catch (e) {
      console.log(e);
    }
    return comment;
  };

  initialize = async () => {
    const { brandId, shouldCancel } = this.props;
    if (!brandId) return;
    try {
      if (shouldCancel) return;
      await BrandsActions.readComments({ brandId });
    } catch (e) {
      console.log(e);
    }
  };

  componentDidMount() {
    this.initialize();
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.brandId !== this.props.brandId) {
      this.initialize();
    }
  }

  onReadReplies = (commentId: string, parentId?: ?string) => {
    const { brandId } = this.props;
    if (!brandId) return Promise.resolve(null);
    return BrandsActions.readSubComments({
      brandId,
      commentId,
      parentId,
    });
  };

  render() {
    const {
      comments,
      subCommentsMap,
      logged,
      loading,
      username,
      removeComment,
      commentsCount,
    } = this.props;

    if (loading) return null;

    return (
      <Fragment>
        <BrandComments
          logged={logged}
          commentInput={logged && <BrandCommentInput onWriteComment={this.onWriteComment} />}
          comments={comments}
          subCommentsMap={subCommentsMap}
          onReply={this.onWriteComment}
          onReadReplies={this.onReadReplies}
          username={username}
          onOpenRemove={this.onOpenRemove}
          onEditComment={this.onEditComment}
          commentsCount={commentsCount || 0}
          currentPath={this.props.location.pathname}
        />
        <QuestionModal
          title="브랜드 댓글 삭제"
          description="이 브랜드 댓글을 정말로 삭제하시겠습니까?"
          confirmText="삭제하기"
          onConfirm={this.onConfirmRemove}
          onCancel={this.onCancelRemove}
          open={removeComment.visible}
        />
      </Fragment>
    );
  }
}

export default connect(
  (state: State) => ({
    logged: !!state.user.user,
    brandId: state.brands.brand && state.brands.brand.id,
    comments: state.brands.comments,
    subCommentsMap: state.brands.subCommentsMap,
    shouldCancel: state.common.ssr && !state.common.router.altered,
    loading: !state.brands.brand || state.pender.pending['brands/READ_COMMENTS'],
    username: state.user.user && state.user.user.username,
    removeComment: state.brands.removeComment,
    commentsCount: state.brands.brand && state.brands.brand.comments_count,
  }),
  () => ({}),
)(withRouter(BrandCommentsContainer));



// WEBPACK FOOTER //
// ./src/containers/brand/BrandCommentsContainer.js